// Overridden in ee/app/assets/javascripts/authentication/sign_in/utils.js
export const showPasskeySignIn = () => {
  return true;
};
